import { IconSet } from '@postscript/components';

export const RcsMessageCategories = {
  CARD: 'CARD',
  CAROUSEL: 'CAROUSEL',
  TEXT: 'TEXT',
} as const;

export const RcsMessageCategoryLabels = {
  [RcsMessageCategories.CARD]: 'RCS Card',
  [RcsMessageCategories.CAROUSEL]: 'RCS Card Carousel',
  [RcsMessageCategories.TEXT]: 'Text RCS',
} as const;

export const RcsMessageCategoryShortLabels = {
  ...RcsMessageCategoryLabels,
  [RcsMessageCategories.CAROUSEL]: 'RCS Carousel',
} as const;

export const RcsMessageButtonTypes = {
  CLICK_TO_REPLY: 'click_to_reply',
  CREATE_CALENDAR_EVENT: 'create_calendar_event',
  OPEN_URL: 'open_url',
} as const;

export const getRcsButtonIcon = (type: string) => {
  if (type === RcsMessageButtonTypes.CLICK_TO_REPLY) return IconSet.Message;
  if (type === RcsMessageButtonTypes.CREATE_CALENDAR_EVENT)
    return IconSet.Calendar;
  return IconSet.Link;
};

export const OpenUrlInOptions = {
  WEBVIEW_FULL: 'webview_full',
  WEBVIEW_TALL: 'webview_tall',
  WEBVIEW_HALF: 'webview_half',
} as const;

export const WebviewHeights = {
  FULL: 'full',
  THREE_QUARTER: 'three_quarter',
  HALF: 'half',
} as const;

export const RcsMessageCardOrientations = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
} as const;
